import React from 'react'
import { observer } from 'mobx-react'

const VatTooltip = () => {
  return (
    <div>
      <div>0% - No VAT</div>
      <br />
      <br />
      <div>
        Intra-community and international transport (excluding road and rail and
        some inland waterways transport).
      </div>
      <br />
      <br />
      <div>7% - Reduced VAT (Germany only)</div>
      <br />
      <br />
      <div>
        Food & Beverage; water supplies; medical equipment for disabled persons;
        domestic passenger transport; intra-community and international
        passenger transport for certain road, rail and inland waterway
        transportation; books (excluding e-books); newspapers and periodicals;
        admission to cultural events; writers and composers; some agricultural
        supplies (fertilizers); hotel accommodation; certain admission to sports
        events; social services; medical and dental care; firewood; some timber
        for industrial use; take away food; cut flowers and plants for
        decorative use and food production; taxation of some gold coins and
        jewellery.
      </div>
      <br />
      <br />
      <div>16% - Standard VAT Reduced (Germany only)</div>
      <br />
      <br />
      <div>All other taxable goods and services.</div>
      <br />
      <br />
      <div>19% - Standard VAT (Germany only)</div>
      <br />
      <br />
      <div>All other taxable goods and services.</div>
    </div>
  )
}

export default observer(VatTooltip)
